var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16667 13.8889H14.0556C14.393 13.8889 14.6667 13.6153 14.6667 13.2778C14.6667 12.9402 14.393 12.6667 14.0556 12.6667H9.16667C8.83056 12.6667 8.55556 12.9417 8.55556 13.2778C8.55556 13.6139 8.83056 13.8889 9.16667 13.8889ZM4.27778 13.8889H6.72222C7.05833 13.8889 7.33333 13.6139 7.33333 13.2778C7.33333 12.9417 7.05833 12.6667 6.72222 12.6667H4.27778C3.94167 12.6667 3.66667 12.9417 3.66667 13.2778C3.66667 13.6139 3.94167 13.8889 4.27778 13.8889ZM19.5556 0.444458H2.44444C1.09427 0.444458 0 1.53873 0 2.8889V15.1111C0 16.4613 1.09427 17.5556 2.44444 17.5556H19.5556C20.9057 17.5556 22 16.4613 22 15.1111V2.8889C22 1.53873 20.9038 0.444458 19.5556 0.444458ZM20.7778 15.1111C20.7778 15.7849 20.2293 16.3333 19.5556 16.3333H2.44444C1.77069 16.3333 1.22222 15.7849 1.22222 15.1111V9.00001H20.7778V15.1111ZM20.7778 7.77779H1.22222V5.33335H20.7778V7.77779ZM20.7778 4.11112H1.22222V2.8889C1.22222 2.21515 1.77069 1.66668 2.44444 1.66668H19.5556C20.2293 1.66668 20.7778 2.21515 20.7778 2.8889V4.11112Z",
    fill: "#717378"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.dcbb4d11b92498d090e7e098a8479962.svg";
export { ForwardRef as ReactComponent };